import React from 'react';
import classnames from 'classnames';

// Type
// import { CalendarMeeting } from 'Shared/types/CalendarMeeting.type';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './DayEventSection.scss';

type Props = {
  icon: string;
  postfixIcon?: string;
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  onClick?: Function;
};

const DayEventSection = ({ icon, postfixIcon, title, subTitle, onClick }: Props) => {
  const handleClick = () => {
    if (onClick) onClick();
  };
  const baseClassName = 'DayEventSection';
  const classes = classnames(baseClassName, onClick ? `${baseClassName}--hover` : '');

  return (
    <div className={classes} onClick={handleClick}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name={icon} size="sm" />
      </div>
      <div className={`${baseClassName}__title`}>
        {title}
        {subTitle && <div className={`${baseClassName}__title__sub-title`}>{subTitle}</div>}
      </div>
      {postfixIcon && (
        <div className={`${baseClassName}__postfix-icon`}>
          <WpIcon name={postfixIcon} />
        </div>
      )}
    </div>
  );
};

export default DayEventSection;
